import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../../../../../components/CustomMultipleDateRange/CustomMultipleDateRange";

const SalaryModal = ({
  isOpen,
  toggle,
  editData,
  permissions,
  updateSalary,
  addSalary,
  user_id
}) => {
  const [rate, setRate] = React.useState("");
  const [dateRange, setDateRange] = React.useState({});

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      setRate(editData?.rate);
      setDateRange({
        start_date:
          editData?.date_from == null ? undefined : editData?.date_from,
        end_date: editData?.date_to == null ? undefined : editData?.date_to,
      });
    } else {
      //
    }
  }, [isOpen]);

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let data = {
        rate: params.rate,
        date_from: dateRange.start_date,
        date_to: dateRange.end_date,
        user: user_id,
      };

      if (editData !== null) {
        updateSalary(user_id, editData.id, data)
        toggle();
      } else {
        addSalary(user_id, data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} size="sm" autoFocus centered toggle={toggle}>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            {editData !== null ? "Edit" : "Add"} salary condition
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col sm={12}>
              <Col sm>
                <Label htmlFor="">Date:</Label>
                <FormGroup className="mb-3">
                  <CustomMultipleDateRange
                    placeholder="Select date..."
                    name="month"
                    defaultText={editData !== null ? dateRange : null}
                    datePickerType={"round-with-present"}
                    errorText=" "
                    onChange={e => setDateRange(e)}
                    required
                  />
                </FormGroup>
              </Col>
              <Col sm>
                <FormGroup className="mb-3">
                  <Label>Rate $</Label>
                  <AvField
                    name="rate"
                    type="number"
                    placeholder="Rate..."
                    errorMessage="This value is required"
                    value={rate}
                    onChange={e => setRate(e.target.value)}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please, enter rate",
                      },
                    }}
                  />
                </FormGroup>
              </Col>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_salaryconditionsmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

const Tire = styled.span`
  position: relative;
  width: 10px;
  vertical-align: middle;
  right: 4px;
  top: 8px;
`;

SalaryModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  editData: PropTypes.any,
  updateSalary: PropTypes.func,
  addSalary: PropTypes.func,
  user_id: PropTypes.string
};

export default SalaryModal;
